// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1go9G","header":"Messages_header__3g6Tz"};